/** Team review. Assessment names/tooltips: catalogs/assessments.js. */
const dictionary = {
  "en": {
    "assessmentsInfo": "Invite your team members to take the selected assessments. Assessments you select will be opened to the employees in the team.",
    "addNewTeam": "Add new team",
    "teamMembers": "Team members",
    "teamName": "Team name",
    "teamMembersList": "Team members list",
    "inviteNewMember": "Invite new team member",
    "viewMembers": "View Members",
    "departmentsList": "Departments List",
    "selectJobDepartment": "Select job department",
    "memberCount": "{count} members",
    "unsavedChanges": "unsaved changes",
    "unsavedChangesCta": "(Click Save Button)",
    "inviteUrlTitle": "Invite Url Is User Specific",
    "resendInvite": "Resend Invite",
    "copyInviteUrl": "Copy Invite Url",
    "removeMember": "Remove Member",
    "tabs": {
      "general": "general",
      "assessments": "assessments"
    },
    "deleteConfirmTitle": "Please confirm that you want to delete this team {title}",
    "deleteConfirmCannotUndo": "This action cannot be undone.",
    "deleteConfirmData": "All data related to this team will be permanently deleted.",
    "deleteConfirmTalentAccess": "However, team members can still access their own data on Talent platform.",
    "ctaIntro": "See how your employees and candidates can team up!",
    "ctaTry": "Try the Team Simulator >>",
    "progress": {
      "completedOfRequired": "Completed {completed} of {total} required assessments",
      "requiredNote": "Your team ask you to complete these assessments before proceeding",
      "moreDetails": "More details",
      "completedAlt": "completed",
      "assessmentNumber": "Assessment #{id}"
    },
    "stepper": {
      "generalInfo": "General info",
      "assessments": "Assessments",
      "allCompleted": "All steps completed - you're finished"
    },
    "toasts": {
      "updated": "Team updated successfully",
      "updateError": "Unable to make update. Please try again or contact support.",
      "deleted": "Team deleted successfully",
      "deleteError": "Unable to delete team. Please try again or contact support.",
      "deleteSystemError": "System error while deleting the team. Please try again or contact support.",
      "deleteUnexpected": "An unexpected error occurred while deleting the team. Please try again or contact support.",
      "memberExists": "Member with this email already exists in the team.",
      "inviteResent": "Invite resent successfully",
      "inviteResendError": "Unable to resend invite. Please try again, or contact support.",
      "created": "Save new team successfully",
      "createError": "Unable to save new team. Please try again, or contact support."
    }
  },
  "de": {
    "assessmentsInfo": "Laden Sie Ihre Teammitglieder ein, die ausgewählten Assessments durchzuführen. Die von Ihnen ausgewählten Assessments werden für die Mitarbeitenden im Team geöffnet.",
    "addNewTeam": "Neues Team hinzufügen",
    "teamMembers": "Teammitglieder",
    "teamName": "Teamname",
    "teamMembersList": "Teammitgliederliste",
    "inviteNewMember": "Neues Teammitglied einladen",
    "viewMembers": "Mitglieder anzeigen",
    "departmentsList": "Abteilungsliste",
    "selectJobDepartment": "Abteilung wählen",
    "memberCount": "{count} Mitglieder",
    "unsavedChanges": "ungespeicherte Änderungen",
    "unsavedChangesCta": "(Auf Speichern klicken)",
    "inviteUrlTitle": "Die Einladungs-URL ist nutzerspezifisch",
    "resendInvite": "Einladung erneut senden",
    "copyInviteUrl": "Einladungs-URL kopieren",
    "removeMember": "Mitglied entfernen",
    "tabs": {
      "general": "allgemein",
      "assessments": "assessments"
    },
    "deleteConfirmTitle": "Bitte bestätigen Sie, dass Sie dieses Team {title} löschen möchten",
    "deleteConfirmCannotUndo": "Diese Aktion kann nicht rückgängig gemacht werden.",
    "deleteConfirmData": "Alle Daten zu diesem Team werden dauerhaft gelöscht.",
    "deleteConfirmTalentAccess": "Teammitglieder können weiterhin auf ihre eigenen Daten auf der Talent-Plattform zugreifen.",
    "ctaIntro": "Finden Sie heraus, wie Ihre Mitarbeitenden und Kandidat:innen zusammenpassen!",
    "ctaTry": "Teamsimulator ausprobieren >>",
    "progress": {
      "completedOfRequired": "{completed} von {total} erforderlichen Assessments abgeschlossen",
      "requiredNote": "Ihr Team bittet Sie, diese Assessments abzuschließen, bevor Sie fortfahren",
      "moreDetails": "Mehr Details",
      "completedAlt": "abgeschlossen",
      "assessmentNumber": "Assessment #{id}"
    },
    "stepper": {
      "generalInfo": "Allgemeine Infos",
      "assessments": "Assessments",
      "allCompleted": "Alle Schritte abgeschlossen – Sie sind fertig"
    },
    "toasts": {
      "updated": "Team erfolgreich aktualisiert",
      "updateError": "Aktualisierung nicht möglich. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.",
      "deleted": "Team erfolgreich gelöscht",
      "deleteError": "Team konnte nicht gelöscht werden. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.",
      "deleteSystemError": "Systemfehler beim Löschen des Teams. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.",
      "deleteUnexpected": "Beim Löschen des Teams ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.",
      "memberExists": "Ein Mitglied mit dieser E-Mail existiert bereits im Team.",
      "inviteResent": "Einladung erfolgreich erneut gesendet",
      "inviteResendError": "Einladung konnte nicht erneut gesendet werden. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.",
      "created": "Neues Team erfolgreich gespeichert",
      "createError": "Neues Team konnte nicht gespeichert werden. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support."
    }
  },
  "fi": {
    "assessmentsInfo": "Kutsu tiimisi jäsenet tekemään valitut arvioinnit. Valitsemasi arvioinnit avautuvat tiimin työntekijöille.",
    "addNewTeam": "Lisää uusi tiimi",
    "teamMembers": "Tiimin jäsenet",
    "teamName": "Tiimin nimi",
    "teamMembersList": "Tiimin jäsenten lista",
    "inviteNewMember": "Kutsu uusi tiimin jäsen",
    "viewMembers": "Näytä jäsenet",
    "departmentsList": "Osastoluettelo",
    "selectJobDepartment": "Valitse osasto",
    "memberCount": "{count} jäsentä",
    "unsavedChanges": "tallentamattomat muutokset",
    "unsavedChangesCta": "(Napsauta Tallenna-painiketta)",
    "inviteUrlTitle": "Kutsulinkki on käyttäjäkohtainen",
    "resendInvite": "Lähetä kutsu uudelleen",
    "copyInviteUrl": "Kopioi kutsulinkki",
    "removeMember": "Poista jäsen",
    "tabs": {
      "general": "yleinen",
      "assessments": "arvioinnit"
    },
    "deleteConfirmTitle": "Vahvista, että haluat poistaa tiimin {title}",
    "deleteConfirmCannotUndo": "Tätä toimintoa ei voi kumota.",
    "deleteConfirmData": "Kaikki tähän tiimiin liittyvät tiedot poistetaan pysyvästi.",
    "deleteConfirmTalentAccess": "Tiimin jäsenet voivat kuitenkin yhä käyttää omia tietojaan Talent-alustalla.",
    "ctaIntro": "Katso, miten työntekijäsi ja hakijasi toimisivat yhdessä tiiminä!",
    "ctaTry": "Kokeile tiimisimulaattoria >>",
    "progress": {
      "completedOfRequired": "Suoritettu: {completed}/{total} vaadittua arviointia",
      "requiredNote": "Tiimisi pyytää sinua suorittamaan nämä arvioinnit, ennen kuin jatkat",
      "moreDetails": "Lisätietoja",
      "completedAlt": "suoritettu",
      "assessmentNumber": "Arviointi #{id}"
    },
    "stepper": {
      "generalInfo": "Yleiset tiedot",
      "assessments": "Arvioinnit",
      "allCompleted": "Kaikki vaiheet suoritettu – valmista tuli!"
    },
    "toasts": {
      "updated": "Tiimi päivitetty",
      "updateError": "Päivityksen tekeminen ei onnistunut. Yritä uudelleen tai ota yhteyttä tukeen.",
      "deleted": "Tiimi poistettu",
      "deleteError": "Tiimin poistaminen ei onnistunut. Yritä uudelleen tai ota yhteyttä tukeen.",
      "deleteSystemError": "Järjestelmävirhe tiimiä poistettaessa. Yritä uudelleen tai ota yhteyttä tukeen.",
      "deleteUnexpected": "Tiimiä poistettaessa tapahtui odottamaton virhe. Yritä uudelleen tai ota yhteyttä tukeen.",
      "memberExists": "Tiimissä on jo jäsen tällä sähköpostiosoitteella.",
      "inviteResent": "Kutsu lähetetty uudelleen",
      "inviteResendError": "Kutsun uudelleen lähettäminen ei onnistunut. Yritä uudelleen tai ota yhteyttä tukeen.",
      "created": "Uusi tiimi tallennettu",
      "createError": "Uuden tiimin tallentaminen ei onnistunut. Yritä uudelleen tai ota yhteyttä tukeen."
    }
  }
};

export default dictionary;
